import React from 'react';
import './TopHeader.css';
import { RiUserLocationLine } from 'react-icons/ri';
import { NavLink } from 'react-router-dom';
import { MdPermPhoneMsg } from 'react-icons/md';
import { MdMarkEmailUnread } from "react-icons/md";

const TopHeader = () => {
  return (
    <div>
      <header className="header_header">
        <div className="logo_logo">
          {/* <img src="./images/gifco.png" alt="Company Logo"/> */}
          {/* <NavLink className="navbar-brand navbar-logo" to="/" exact style={{ fontFamily: "Nunito", fontWeight: "800" }}>
            GIFCO AUTO FILTERS INDIA
          </NavLink> */}

         

        </div>
        <div className="info_info">
          <p className="address_address " >
            <RiUserLocationLine style={{ fontSize: "25px", marginRight: "10px", animation: "zoomInOut 2s infinite alternate",color:"white" }} className="location-icon" />No.91/2, Garudacharpalya, Mahadevapura Post, Behind Brigade Metropolis, Bengaluru-560048
          </p>
          <p className="contact_contact responsive_topheader" > <MdPermPhoneMsg style={{ fontSize: "25px", marginRight: "10px", animation: "ring 2s infinite",color:"white" }} className="phone-icon" />+91 9845164986/9980411999/7892882698{"  "} <span style={{marginLeft:"15px"}} ><MdMarkEmailUnread style={{ fontSize: "25px", marginRight: "10px", animation: "zoomInOut 2s infinite alternate", }} className="location-icon" /><a href='mailto:gifcoautofilters@gmail.com' style={{color:"white",textDecoration:'none'}}>gifcoautofilters@gmail.com</a></span>  </p>
          
        </div>
        

      </header>
      
    </div>
  );
};

export default TopHeader;
